import { validateToken } from "../../components/Globais";
// --------------------- Import React ---------------------
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// --------------------- Import Antd-Design ---------------------

import {
  Col,
  Flex,
  Row,
  MenuProps,
  Skeleton,
  Table,
  Typography,
  Button,
} from "antd";

// --------------------- Import Material Icon ---------------------
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import HomeIcon from "@mui/icons-material/Home";
import { useMediaQuery } from "@mui/material";

// --------------------- Import Styles ---------------------
import { Container } from "./styles";

// --------------------- Import Hooks ---------------------
import { useError } from "../../uteis/mensagens/useError";
import { useSuccess } from "../../uteis/mensagens/useSuccess";
import { useWarning } from "../../uteis/mensagens/useWarning";
import { useReservas } from "./hooks/useReservas";
import { usePermissao } from "./hooks/usePermissao";
import { useAtualizarReservaStatus } from "./hooks/useAtualizarReservaStatus";

// --------------------- Import Components ---------------------
import { Columns } from "./components/Columns";
import ModalHospedes from "../ViewGerenciarReserva/components/ModalHospedes";
import ModalCancelar from "./components/ModalCancelar";
import ModalAutorizacao from "./components/ModalAutorizacao";
import ModalConfirmar from "./components/ModalConfirmar";
import ModalRecebimentoMC from "./components/ModalRecebimentoMC";
import ModalPagamentoProp from "./components/ModalPagamentoProp";
import ModalAdicionar from "../ViewGerenciarReserva/components/ModalAdicionar";

// ---------------------  ---------------------

export default function ViewListarReservas() {
  const Token = validateToken();

  // Traz o estilo Title da biblioteca
  const { Title } = Typography;

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Exibe a Mensagem de  Erro
  const { showWarning, contextHolder: warningContextHolder } = useWarning();

  // Realiza a busca das reservas cadastradas

  const { reservas, isLoading: isReservasLoading } = useReservas();
  // Verificação de permissão do usuário, NDA = 0 - SEM PERMISSÃO, NDA = 1 - COM PERMISSÃO

  // Definação do Loading caso seja permitido
  const { isLoading: isTokenLoading, isValid } = usePermissao();

  // Controle de Paginação
  const currentPage = useRef(1);

  const [msgAlert, setMsgAlert] = useState<string | null>(null);

  // Armazena o valor da reserva selecionada
  const [reservaId, setReservaId] = useState<number | null>(null);

  // Armazena o valor da reserva selecionada
  const [proprietarioId, setProprietarioId] = useState<number | null>(null);

  // Armazena o valor da reserva selecionada
  const [cotaUsuario, setCotaUsuario] = useState<number | null>(null);

  // Armazena o valor da reserva selecionada
  const [nomeEmpreend, setNomeEmpreend] = useState<string | null>(null);

  // Armazena o valor da reserva selecionada
  const [checkIn, setCheckIn] = useState<string | null>(null);

  // Armazena o valor da reserva selecionada
  const [checkOut, setCheckOut] = useState<string | null>(null);

  // Armazena o valor da reserva selecionada ao selecionar uma das opções em ações
  const [idReservaAtualizar, setIdReservaAtualizar] = useState<number | null>(
    null
  );
  // Armazena o valor do status para alterar a reserva
  const [reservaStatus, setReservaStatus] = useState<string>("");

  // State de abertura e fechamento do modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  // State de abertura e fechamento do modal
  const [isModalCancelarOpen, setIsModalCancelarOpen] = useState(false);

  // State de abertura e fechamento do modal
  const [isModalAutorizacaoOpen, setIsModalAutorizacaoOpen] = useState(false);

  // State de abertura e fechamento do modal
  const [isModalConfirmarOpen, setIsModalConfirmarOpen] = useState(false);

  // State de abertura e fechamento do modal
  const [isModalPagamentoPropOpen, setIsModalPagamentoPropOpen] =
    useState(false);

  // State de abertura e fechamento do modal
  const [isModalRecebimentoMcOpen, setIsModalRecebimentoMcOpen] =
    useState(false);

  // Funçao para abrir o modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  // Funçao para fechar o modal
  const handleFechar = () => {
    setIsModalOpen(false);
  };

  // Funçao para abrir o modal
  const showModalCancelar = () => {
    setIsModalCancelarOpen(true);
  };

  // Funçao para fechar o modal
  const handleCancelarFechar = () => {
    setIsModalCancelarOpen(false);
  };

  // Funçao para abrir o modal
  const showModalAutorizacao = () => {
    setIsModalAutorizacaoOpen(true);
  };

  // Funçao para fechar o modal
  const handleAutorizacaoFechar = () => {
    setIsModalAutorizacaoOpen(false);
  };

  // Funçao para abrir o modal
  const showModalConfirmar = () => {
    setIsModalConfirmarOpen(true);
  };

  // Funçao para fechar o modal
  const handleConfirmarFechar = () => {
    setIsModalConfirmarOpen(false);
  };

  // Funçao para abrir o modal
  const showModalRecebimentoMC = () => {
    setIsModalRecebimentoMcOpen(true);
  };

  // Funçao para fechar o modal
  const handleRecebimentoMcFechar = () => {
    setIsModalRecebimentoMcOpen(false);
  };

  // Funçao para abrir o modal
  const showModalPagamentoProp = () => {
    setIsModalPagamentoPropOpen(true);
  };

  // Funçao para fechar o modal
  const handlePagamentoPropFechar = () => {
    setIsModalPagamentoPropOpen(false);
  };

  // Função utilizada para atualizar o status da reserva
  const {
    reservaStatusAtualizado,
    success: successStatus,
    error: errorStatus,
  } = useAtualizarReservaStatus(idReservaAtualizar, reservaStatus);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o erro já foi exibido
  const [warningDisplayed, setWarningDisplayed] = useState(false);

  // Funçao navigate que é utilizada para o reload da página
  const navigate = useNavigate();

  // OnClick das opções e funções que serão realizadas do item Ações
  const onClick: MenuProps["onClick"] = async ({ key }) => {
    switch (key) {
      case "1":
        showModal();
        break;

      case "2":
        showModalAutorizacao();
        break;

      case "3":
        showModalConfirmar();
        break;
      case "5":
        showModalRecebimentoMC();
        break;
      case "6":
        showError(key);
        break;
      case "6-1":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("AGUARDANDO_HOSPEDES"); // Define o status da reserva a ser atualizado
        }

        break;
      case "6-2":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("AGUARDANDO_AUTORIZACAO"); // Define o status da reserva a ser atualizado
        }
        break;
      case "6-3":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("AGUARDANDO_CHECKIN"); // Define o status da reserva a ser atualizado
        }
        break;
      case "6-4":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("AGUARDANDO_PAGAMENTO_PROPRIETARIO"); // Define o status da reserva a ser atualizado
        }
        break;
      case "6-5":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("AGUARDANDO_PAGAMENTO_MC"); // Define o status da reserva a ser atualizado
        }
        break;

      case "6-6":
        if (reservaId) {
          Token?.nda === 1
            ? showModalCancelar()
            : setMsgAlert("Somento ADM pode acessar essa função");
          // Define o status da reserva a ser atualizado
        }
        break;
      case "6-7":
        if (reservaId) {
          setIdReservaAtualizar(reservaId); // Define o ID da reserva a ser atualizado
          setReservaStatus("FINALIZADO"); // Define o status da reserva a ser atualizado
        }
        break;
      case "7":
        showModalPagamentoProp();
        break;
      default:
        showError(key);
        break;
    }
  };

  // Combina os estados de sucesso e erro para simplificar a lógica
  const successMessage = successStatus;
  const errorMessage = errorStatus;

  // useEffect para lidar com o sucesso
  useEffect(() => {
    if (reservaStatusAtualizado && successMessage && !successDisplayed) {
      showSuccess(successMessage);
      setSuccessDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 1000);
    }
  }, [
    reservaStatusAtualizado,
    successMessage,
    showSuccess,
    successDisplayed,
    navigate,
  ]);

  // useEffect para lidar com o erro
  useEffect(() => {
    if (!reservaStatusAtualizado && errorMessage && !errorDisplayed) {
      showError(errorMessage);
      setErrorDisplayed(true);
      setTimeout(() => {
        navigate(0); // Simula um refresh completo
      }, 1000);
    }
  }, [
    reservaStatusAtualizado,
    errorMessage,
    showError,
    errorDisplayed,
    navigate,
  ]);

  // useEffect para lidar com o erro
  useEffect(() => {
    if (msgAlert && !warningDisplayed) {
      showWarning(msgAlert);
      setWarningDisplayed(true);
      setTimeout(() => {
        setWarningDisplayed(false);
        setMsgAlert(null); // Simula um refresh completo
      }, 3000);
    }
  }, [msgAlert, showWarning, warningDisplayed]);

  // Traz os dados das colunas (onClick, ReservaId )
  const columns = Columns(
    onClick,
    setReservaId,
    setNomeEmpreend,
    setCheckIn,
    setCheckOut,
    setProprietarioId,
    setCotaUsuario
  );

  // Define o width para mobile
  const isMobile = useMediaQuery("(max-width:600px)");

  // State de abertura e fechamento do modal (Adicionar Lead)
  const [isModalAdicionarOpen, setIsModalAdicionarOpen] = useState(false);

  // Funçao para abrir o modal (Adicionar Apartamento)
  const adicionarModal = () => {
    setIsModalAdicionarOpen(true);
  };

  // Funçao para fechar o modal (Editar Adicionar)
  const handleAdicionarFechar = () => {
    setIsModalAdicionarOpen(false);
  };

  // ---------------------  ---------------------
  return (
    <>
      {isTokenLoading || !isValid || isReservasLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <>{errorContextHolder}</>
          <>{successContextHolder}</>
          <>{warningContextHolder}</>
          <Row>
            <Col span={5}>
              <Flex align="center" justify="center" style={{ marginTop: 15 }}>
                <a href={`/inicio`}>
                 
                </a>
              </Flex>
            </Col>
            <Col span={12}>
              <Flex align="center" justify="center">
                <HomeIcon color="primary" fontSize="large" />
                <Title
                  style={{
                    marginLeft: 10,
                    marginTop: 10,
                    fontSize: isMobile ? "1rem" : "2rem",
                    color: "rgb(0, 54, 68)",
                  }}
                  level={3}
                >
                  Todas as reservas
                </Title>
              </Flex>
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end", // Alinha o conteúdo à direita
                alignItems: "center",
                height: "auto",
                width: "90%", // Garante que ocupe toda a largura disponível
                gap: "20px", // Espaço entre os botões
              }}
            >
              <Button
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "auto",
                }}
                onClick={adicionarModal}
                type="primary"
              >
                + Reserva
              </Button>
            </div>
            <Col span={isMobile ? 5 : 1}></Col>
            <Col
              span={22}
              style={{
                marginTop: isMobile ? 15 : 15,
                marginBottom: isMobile ? 30 : 50,
              }}
            >
              <Flex
                style={{
                  width: isMobile ? "auto" : "100%",
                  overflow: "auto",
                  marginLeft: 30,
                }}
              >
                <Table
                  columns={columns}
                  dataSource={reservas}
                  bordered
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    width: isMobile ? "auto" : "100%",
                    maxWidth: isMobile ? "none" : "100%",
                  }}
                  pagination={{ defaultCurrent: currentPage.current }}
                />
              </Flex>
            </Col>
            <Col span={1}></Col>
          </Row>
          <ModalHospedes
            isModalOpen={isModalOpen}
            handleFechar={handleFechar}
            reservaId={reservaId}
          />
          <ModalCancelar
            isModalOpen={isModalCancelarOpen}
            handleFechar={handleCancelarFechar}
            reservaId={reservaId}
            nomeEmpreend={nomeEmpreend}
            checkIn={checkIn}
            checkOut={checkOut}
            proprietarioId={proprietarioId}
          />
          <ModalAutorizacao
            isModalOpen={isModalAutorizacaoOpen}
            handleFechar={handleAutorizacaoFechar}
            cotaUsuario={cotaUsuario}
            reservaId={reservaId}
          />
          <ModalConfirmar
            isModalOpen={isModalConfirmarOpen}
            handleFechar={handleConfirmarFechar}
            reservaId={reservaId}
          />
          <ModalRecebimentoMC
            isModalOpen={isModalRecebimentoMcOpen}
            handleFechar={handleRecebimentoMcFechar}
            reservaId={reservaId}
          />
          <ModalPagamentoProp
            isModalOpen={isModalPagamentoPropOpen}
            handleFechar={handlePagamentoPropFechar}
            reservaId={reservaId}
          />

          <ModalAdicionar
            isModalOpen={isModalAdicionarOpen}
            handleFechar={handleAdicionarFechar}
          />
        </Container>
      )}
    </>
  );
}
